import {FC, useContext, useEffect, useState} from "react";
import {IGroup} from "../types/ApiTypes";
import {useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import {useAccount} from "@azure/msal-react";
import {GroupsContext} from "../context/GroupsContext";
import {toast} from "react-hot-toast";
import Card from "../components/ui/Card";
import Textarea from "../components/ui/Textarea";
import Loading from "../components/Loading";

const SpaceEdit: FC = () => {
    const [space, setSpace] = useState<IGroup>();
    const [spaceLoading, setSpaceLoading] = useState(false);
    const {register, formState:{errors}} = useForm<{ reason: string }>({
        mode: 'onChange'
    });

    const params = useParams<{id: string}>();
    const account = useAccount();
    const navigate = useNavigate();
    const groupCtx = useContext(GroupsContext);

    useEffect(() => {
        setSpaceLoading(true);
        if(groupCtx.state.groups.length > 0 && account) {
            const group = groupCtx.state.groups.find(x => x.requestId === params.id);
            if(!group) {
                toast.error('Space with ID: '+params.id+' wurde nicht gefunden');
                return navigate('/not-found');
            }
            if(group.primary_owner !== account.localAccountId && group.secondary_owner !== account.localAccountId) {
                toast.error('Du darfst dieses Space nicht bearbeiten');
                return navigate('/');
            }
            setSpace(group);
            setSpaceLoading(false);
        }
    },[groupCtx.state.groups, params.id, navigate, account])

    return (
        (!spaceLoading && space) ? (
            <section className='grid grid-cols-1'>
                <Card title={`Bearbeite das Space ${space.type} ${space.name}`}>
                    <form>
                        <div>
                            <label className='font-semibold' htmlFor="reason">Begründung</label>
                            <Textarea label='reason' id='reason' {...register('reason',{required:true,minLength:10})}/>
                            {errors.reason ? <small className='text-error-brighter'>Die Begründung muss mindestens 10 Zeichen lang sein</small> : <small>Deine Entscheidung benötigt eine Begründung</small>}
                        </div>
                    </form>
                </Card>
            </section>
        ) : (<Loading/>)
    );
};

export default SpaceEdit;